// 62820
'use strict';
// 100034, 165827
$(document).ready(function () {
    $(document).on('click keyup', '.explore-courses-carousel li a', function (e) {
        $('.product-tiles__list').slick('destroy');
        $('.product-tiles__list').slick({
            dots: false,
            arrows: true,
            slidesToShow: 3,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: true,
                        dots: true,
                        infinite: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 2,
                        infinite: true
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 1,
                        infinite: true
                    }
                }
            ]
        });
    });
// 76175
    $('.product-tiles__list').slick({
        dots: false,
        arrows: true,
        slidesToShow: 3,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    dots: true,
                    infinite: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    infinite: true
                }
            }
        ]
    });
    $(document).on('afterChange', '.product-tiles__list', function (slick) {
        // 25291 start
        setTimeout(() => {
            $(this).find('.slick-current').find('a').eq(0)
                .focus();
        }, 300);
        // 25291 end
    });
});

$(window).on('load', function () {
    $('.slick-arrow').each(function () {
        $(this).attr('title', $(this).attr('aria-label'));
    });
});
